<template>
    <b-input-group :size="size">
        <b-input-group-prepend v-if="$slots.prepend">
            <slot name="prepend"></slot>
        </b-input-group-prepend>
        <b-form-input ref="input"
                      v-bind="$attrs"
                      :required="required"
                      :placeholder="placeholder"
                      :disabled="disabled"
                      :type="type"
                      :readonly="readonly"
                      :name="name ? name : randomAttributeValueString()"
                      :autofocus="autofocus"
                      :autocomplete="autocomplete !== 'off' ? autocomplete : randomAttributeValueString()"
                      :value="value"
                      :state="state"
                      :min="min"
                      :max="max"
                      :formatter="formatter"
                      :size="size"
                      v-mask="mask"
                      v-on="$listeners"
                      @focus.native="onFocus"
                      @blur.native="onBlur"/>
        <b-input-group-append v-if="!noControls">
            <div class="valid-indicator" v-if="isValid && loading !== true">
                <i v-b-tooltip.hover title="Заполнено верно" class="fas fa-check-circle"></i>
            </div>
            <transition name="fade">
                <div class="loading-indicator" v-show="loading === true">
                    <b-spinner small variant="primary" label="Spinning"></b-spinner>
                </div>
            </transition>
            <b-btn v-if="!noBackspace"
                   ref="clearButton"
                   :size="size"
                   :disabled="!value || disabled || readonly"
                   @click.prevent="changed('')"
                   class="outline-input-special"
                   :class="buttonClasses">
                <i class="far fa-backspace"></i>
            </b-btn>
            <slot name="append"></slot>
        </b-input-group-append>
    </b-input-group>
</template>

<script>
    import props from './props'

    export default {
        name: "InputWrapper",

        props: props,
        computed: {
            buttonClasses() {
                return {
                    'is-focus': this.$data.isFocus,
                    'is-invalid': this.$props.state === false,
                    'is-valid': this.$props.state === true
                }
            }
        },
        data() {
            return {
                isFocus: false
            }
        },
        mounted() {
            this.$props.autofocus && this.focus();
        },
        methods: {
            focus() {
                this.$refs.input && this.$refs.input.$el && this.$refs.input.$el.focus();
            },
            clear() {
                this.$emit('clear');
                this.$emit('input', '');
                this.focus();
            },
            changed(value) {
                this.$emit('input', value);
                this.focus();
            },
            randomAttributeValueString() {
                return Math
                        .random()
                        .toString(36)
                        .substring(2, 15)
                    + Math
                        .random()
                        .toString(36)
                        .substring(2, 15);
            },
            focusListener() {

            },
            onFocus() {
                this.$data.isFocus = true;
            },
            onBlur() {
                this.$data.isFocus = false;
            }
        },
    }
</script>